import React from "react";
import AppRouter from "./pages/AppRouters";
import { ApolloProvider } from "@apollo/client";
import apolloClient from "./core/apolloClient";
import initAWSAmplify from "./core/awsAmplify";
import AuthContext from "./core/authContext";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

initAWSAmplify();

function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <AuthContext>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <AppRouter />
        </LocalizationProvider>
      </AuthContext>
    </ApolloProvider>
  );
}

export default App;
